import React from "react"

import styles from './ManageJvmCacerts.module.scss'
import globalStyles from "../../../../App.module.scss";
import Gist from "react-gist";

export default function ManageJvmCacerts() {
    return (
        <div className={styles.manageCacerts}>
            <h1 className={styles.title}>Manage JVM certificates</ h1>

            <h3>Check the setup</h3>
            <p>To manage JVM certificates from command line it is necessary to have 'keytool', which is part of the
                standard java distribution.</p>
            <p>Finding where the certs are stored is not difficult, just follow the yellow brick road.</p>

            <h4>1. Find JVM home</h4>

            <pre className={globalStyles.code}>
    <b>root@VirtualBox:~#</b> ls -l $(which java)<br/>
    lrwxrwxrwx 1 root root 22 Dec 18 13:00 /usr/bin/java -> /etc/alternatives/java<br/>
    root@jca-VirtualBox:~# ll /etc/alternatives/java<br/>
    lrwxrwxrwx 1 root root 46 Dec 18 13:00 /etc/alternatives/java -> /usr/lib/jvm/java-7-openjdk-amd64/jre/bin/java*<br/>
        </pre>


            <h4>2. Find cacerts file</h4>
            <p>The default location for the certs is the relative path"<em>{"{JAVA HOME}/lib/security/"}</em>".</p>

            <pre className={globalStyles.code}>
    <b>root@VirtualBox:~#</b> ls -l /usr/lib/jvm/java-7-openjdk-amd64/jre/lib/security<br/>
    total 8<br/>
    lrwxrwxrwx 1 root root  27 Nov 19 11:39 cacerts -> /etc/ssl/certs/java/cacerts<br/>
    lrwxrwxrwx 1 root root  40 Nov 19 11:39 java.policy -> /etc/java-7-openjdk/security/java.policy<br/>
    lrwxrwxrwx 1 root root  42 Nov 19 11:39 java.security -> /etc/java-7-openjdk/security/java.security<br/>
    -rw-r--r-- 1 root root 538 Dec  1  2007 local_policy.jar<br/>
    lrwxrwxrwx 1 root root  36 Nov 19 11:39 nss.cfg -> /etc/java-7-openjdk/security/nss.cfg<br/>
    -rw-r--r-- 1 root root 520 Dec  1  2007 US_export_policy.jar<br/>
</pre>
            <p>In this system JVM certificate file is '<em>/etc/ssl/certs/java/cacerts</em>'.</p>

            <h4>3. Confirm that 'keytool' is available</h4>
            <pre className={globalStyles.code}>
         <b>root@VirtualBox:~#</b> ls -l $(which keytool)<br/>
     lrwxrwxrwx 1 root root 25 Dec 18 13:00 /usr/bin/keytool -> /etc/alternatives/keytool<br/>
     <b>root@VirtualBox:~#</b> ll /etc/alternatives/keytool<br/>
     lrwxrwxrwx 1 root root 49 Dec 18 13:00 /etc/alternatives/keytool -> /usr/lib/jvm/java-7-openjdk-amd64/jre/bin/keytool*<br/>
    </pre>
            <p>'keytool' is part of the standard java installation and is located at
                "<em>{"{JAVA HOME}/jre/bin/keytool"}</em>"</p>


            < h3>Add certificates to the system</ h3>
            <h4>1. Fetch the certificate</h4>
            <p>To fetch the certificate you can use the command showed below:</p>
            <pre className={globalStyles.code}><b>user@VirtualBox:~$</b>{"openssl s_client -connect {host}:{port} -showcerts 2>/dev/null | openssl x509 -inform PEM -text -out cert.pem"}</pre>
            <p>{"The resulting file (\"cert.pem\") will look something like this:"}</p>
            <pre className={globalStyles.code}>
         -----BEGIN CERTIFICATE-----<br/>
     MIIf+DCCHuCgAwIBAgIINLbQ6oSzeqAwDQYJKoZIhvcNAQELBQAwSTELMAkGA1UE<br/>
     BhMCVVMxEzARBgNVBAoTCkdvb2dsZSBJbmMxJTAjBgNVBAMTHEdvb2dsZSBJbnRl<br/>
     cm5ldCBBdXRob3JpdHkgRzIwHhcNMTUxMjEwMTc0NjAwWhcNMTYwMzA5MDAwMDAw<br/>
     WjBkMQswCQYDVQQGEwJVUzETMBEGA1UECAwKQ2FsaWZvcm5pYTEWMBQGA1UEBwwN<br/>
     BQcDAjCCG5MGA1UdEQS<br/>
     -----END CERTIFICATE-----<br/>
     </pre>

            <h4>2. Update the certificate</h4>
            <br/>
            <p>I highly recommend to take a backup of the cacerts or keystore file so it is possible to go back to it in
                case something goes wrong</p>
            <pre className={globalStyles.code}><b>root@VirtualBox:~#:</b> cp /etc/ssl/certs/java/cacerts /etc/ssl/certs/java/cacerts.back</pre>
            <p><b>To delete the old certificate:</b></p>
            <pre className={globalStyles.code}>{"keytool --delete -alias {alias} -keystore {cacert or keystore} -storepass {password}"}</pre>
            <p>{"Substitute {alias},{cacerts or keystore} and {password} by the alias of the certificate you want to delete, " +
                "the file in which it is stored and its password. The switch \"-storepass\" is optional, if not used you will " +
                "be prompted to type the password for the certificate file."}</p>
            <pre className={globalStyles.code}><b>root@VirtualBox:~#:</b> keytool --delete -alias testcert -keystore cacerts -storepass changeit</pre>
            <p><b>To import the new certificate:</b></p>
            <pre className={globalStyles.code}>{"keytool --importcert -alias {alias} -file {file.crt}  -keystore {cacerts file} [optional: -storepass {password}"}</pre>
            <pre className={globalStyles.code}><b>root@VirtualBox:~#:</b> keytool --importcert -alias testcert -file cert.pem -keystore cacerts -storepass changeit</pre>
            <p>The challenge now is to keep track of the certificates in all servers and make sure none of them expires
                unnoticed.
                I have created a little tool to help with that. It can be set as a cronjob to run everyday or integrate
                with other tools.
                It will email every day 30 days before the certificate expires.</p>
            <Gist id={"88b1d1551a4fc54a491c"}/>

        </div>

    )
}